import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthRoutingModule } from './auth-routing.module';
import { InfoDialogComponent } from './info-dialog/info-dialog.component';
import {DialogModule} from 'primeng/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { PageLoginImgComponent } from './page-login-img/page-login-img.component';
import {CommentPipe} from "./page-login-img/comment-safe.pipe";
@NgModule({
    declarations: [
    InfoDialogComponent,
    PageLoginImgComponent,
      CommentPipe
  ],
    imports: [
        CommonModule,
        DialogModule,
        TranslateModule,
        ButtonModule,
        AuthRoutingModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    InfoDialogComponent,
    CommonModule,
    ButtonModule,
    TranslateModule,
    PageLoginImgComponent,
  ]
})
export class AuthModule { }
